import { createSelector } from "reselect"
import { findLast, map, get } from "lodash"
import { getSelectedDate } from "modules/security-profile/selectors/dates"
import { isSameTradingDay } from "helpers/dates"
import { getFilteredData, getCategoryItems, getSingleItemCategories } from "./data"

export const getDetails = createSelector(
  [getFilteredData, getCategoryItems, getSingleItemCategories, getSelectedDate],
  (data, items, singleItemCategories, date) => {
    const datum = findLast(data, d => isSameTradingDay(d.date, date))

    return map(items, item => ({
      ...item,
      value: get(datum, item.id),
      secondaryLabel: item.type === "category" ? singleItemCategories[item.id] : undefined,
    }))
  },
)
